"use client";

import { Dialog } from "@headlessui/react";
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";
import { useState } from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../contexts/LanguageContext";
import { useStore } from "../contexts/StoreContext";

export default function TrialEndedAlert({
  isOpen,
  onClose,
  subscriptionStatus,
  title,
  description,
}) {
  const { t } = useLanguage();
  const { canManageStore } = useStore();

  const resolvedTitle =
    title ??
    (subscriptionStatus === "canceled"
      ? "common.subscriptionCanceled"
      : "common.trialEnded");
  const resolvedDescription =
    description ??
    (subscriptionStatus === "canceled"
      ? "common.subscriptionCanceledDescription"
      : "common.trialEndedDescription");

  return (
    <Dialog open={isOpen} onClose={onClose} className="relative z-50">
      <div className="fixed inset-0 bg-gray-500/75 transition-opacity" />

      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6">
            <div className="sm:flex sm:items-start">
              <div className="mx-auto flex size-12 shrink-0 items-center justify-center rounded-full bg-indigo-100 sm:mx-0 sm:size-10">
                <ExclamationTriangleIcon
                  aria-hidden="true"
                  className="size-6 text-indigo-600"
                />
              </div>
              <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                <Dialog.Title
                  as="h3"
                  className="text-base font-semibold text-gray-900"
                >
                  {t(resolvedTitle)}
                </Dialog.Title>
                <div className="mt-2">
                  <p
                    className="text-sm text-gray-500"
                    dangerouslySetInnerHTML={{ __html: t(resolvedDescription) }}
                  />
                </div>
              </div>
            </div>
            {/* Buttons */}
            <div className="mt-5 sm:ml-10 sm:mt-4 sm:flex">
              {/* Plans are the admins' call; /pricing sends a member away. */}
              {canManageStore && (
                <Link
                  to="/pricing"
                  className="mt-3 inline-flex w-full justify-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-indigo-500 sm:ml-3 sm:mt-0 sm:w-auto"
                >
                  {t("common.viewPlans")}
                </Link>
              )}
              <button
                type="button"
                data-autofocus
                onClick={onClose}
                className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-xs ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:ml-3 sm:mt-0 sm:w-auto"
              >
                {t("common.cancel")}
              </button>
            </div>
          </Dialog.Panel>
        </div>
      </div>
    </Dialog>
  );
}
